import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faMagic } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { postData } from '../../../services';
import ConfirmDialog from '../../helpers/ConfirmDialog';

const SERVICE_CONFIG = {
    engineer: {
        endpoint: '/apis/designs/engineer-design',
        triggerTitle: 'Engineer Design',
        triggerIcon: faCog,
        triggerLabel: 'PE Stamps',
        title: 'PE Stamps',
        intro: 'Need PE stamps for your design?',
        pricing: (
            <p>
                Our team of licensed Solar engineers will review and stamp your design for $500.
            </p>
        ),
        invoiceNotice:
            'By proceeding with this request, you confirm that you understand you will be invoiced $500 for this design engineering service.',
        turnaround: 'Your design will be stamped within 3-5 business days.',
        commentsPlaceholder:
            'Add any specific requirements or notes for the engineering team...',
        confirmLabel: 'Confirm & Submit Engineering Request',
        errorMessage:
            'Failed to submit design engineering request. Please try again later.',
    },
    optimize: {
        endpoint: '/apis/designs/optimize-design',
        triggerTitle: 'Optimize Design',
        triggerIcon: faMagic,
        triggerLabel: 'Optimize',
        title: 'Optimize Design',
        intro: 'Ready to take your design to the next level?',
        pricing: (
            <p>
                Our team of Solar professionals will optimize your existing design for maximum
                efficiency and performance for <span className="msrp-price">$100</span>{' '}
                <strong className="solar-pro-price">$25</strong>.
            </p>
        ),
        invoiceNotice:
            'By proceeding with this request, you confirm that you understand you will be invoiced $25 for this design optimization service (regularly $100).',
        turnaround: 'Your design will be reviewed and optimized within 3-5 business days.',
        commentsPlaceholder:
            'Add any specific requirements or notes for the optimization team...',
        confirmLabel: 'Confirm & Submit Optimization Request',
        errorMessage:
            'Failed to submit design optimization request. Please try again later.',
    },
};

export const ServiceRequestForm = ({ project_id, design_id, serviceKey }) => {
    const { token, base_url } = useAppContext();
    const [comments, setComments] = useState('');
    const config = SERVICE_CONFIG[serviceKey];
    const commentsId = `service-request-comments-${serviceKey}`;

    if (!config) {
        console.error(`Unknown service request key: ${serviceKey}`);
        return null;
    }

    return (
        <ConfirmDialog
            trigger={
                <button className="btn btn-secondary btn-action" title={config.triggerTitle}>
                    <FontAwesomeIcon icon={config.triggerIcon} />
                    <span>{config.triggerLabel}</span>
                </button>
            }
            title={config.title}
            confirmLabel={config.confirmLabel}
            submittingLabel="Submitting..."
            onOpenChange={(open) => {
                if (!open) setComments('');
            }}
            errorMessages={{
                notFound: config.errorMessage,
                client: config.errorMessage,
                default: config.errorMessage,
            }}
            onConfirm={async () => {
                const submission = await postData(
                    token,
                    `${base_url}${config.endpoint}`,
                    { project_id, design_id, comments }
                );

                if (!submission.msg) return false;

                if (window.showAlert) {
                    window.showAlert(200, submission.msg);
                }
            }}
        >
            <p>{config.intro}</p>
            {config.pricing}
            <hr />
            <div className="form-stack">
                <div className="alert alert-info">
                    <strong>Important:</strong> {config.invoiceNotice}
                </div>
                <p>{config.turnaround}</p>
                <div>
                    <label htmlFor={commentsId} className="form-label--bold">
                        Comments (Optional):
                    </label>
                    <textarea
                        id={commentsId}
                        name="comments"
                        rows="5"
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                        placeholder={config.commentsPlaceholder}
                        className="form-textarea--comments"
                    />
                </div>
            </div>
        </ConfirmDialog>
    );
};

export const EngineerDesignForm = ({ project_id, design_id }) => (
    <ServiceRequestForm
        project_id={project_id}
        design_id={design_id}
        serviceKey="engineer"
    />
);

export const OptimizeDesignForm = ({ project_id, design_id }) => (
    <ServiceRequestForm
        project_id={project_id}
        design_id={design_id}
        serviceKey="optimize"
    />
);
